/**
 * Company IDs for which the Inbound Call Queuing / agent-availability polling
 * feature is enabled. Only orgs on this list will have the upgraded Salesforce
 * package that handles SCV.CHECK_AGENT_AVAILABILITY — all others skip polling.
 */
export const INBOUND_CALL_QUEUING_COMPANY_IDS: number[] = [502750];
